import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TemplateService } from '@app/services/template.service';

@Component({
  selector: 'app-property-editor',
  templateUrl: './property-editor.component.html',
  styleUrls: ['./property-editor.component.scss']
})
export class PropertyEditorComponent implements OnInit {
  shortcode = '';
  description = '';
  properties: any[] = [];
  /** Options from validvalueslist.ValidVal; property rows still store TemplateValueType. */
  valueTypes: { ValidVal: string; DefaultFlag?: string }[] = [];
  
  constructor(private route: ActivatedRoute, private templateService: TemplateService, private router: Router) {}

  ngOnInit() {
   // debugger;
    this.shortcode = this.route.snapshot.params['shortcode'];
    this.templateService.getValueTypes().subscribe(data => {
      this.valueTypes = Array.isArray(data) ? data : [];
    });
    this.templateService.getTemplateWithSC(this.shortcode).subscribe(template => {
      console.log(template.MTPropertyArr);
      this.description = template.MTDescription;
      this.properties = JSON.parse(template.MTPropertyArr || '[]');
    });
  }

  addProperty() {
    const defaultType =
      this.valueTypes.find(t => String(t.ValidVal || '').toLowerCase() === 'others') ||
      this.valueTypes[0];
    this.properties.push({
      label: '',
      TemplateValueType: defaultType?.ValidVal || '',
      value: ''
    });
  }

  deleteProperty(index: number) {
    this.properties.splice(index, 1);
  }

  save() {
    const updatedTemplate = {
      MTShortCode: this.shortcode,
      MTDescription: this.description,
      MTPropertyArr: this.properties
    };
   console.log("properties in save");
    console.log(this.properties);

    this.templateService.saveTemplate(updatedTemplate).subscribe(() => {
      this.router.navigate(['/designer/template-list']);
    });
  }
}
